import { usePresale } from './usePresale';
import { decimalToApproxNumber } from '@incpt/shared';

/**
 * INCPT as it appears in the asset lists.
 *
 * It is deliberately NOT part of `COINS` / `CoinSymbol`: those drive the
 * on-chain send, receive and swap flows. Off-chain P2P uses a dedicated
 * IncptSendScreen; swap stays locked until listing.
 */
export interface IncptAsset {
  symbol: string;
  /** Contract network the token will list on — display only. */
  network: string;
  /** Exact tokens held (decimal string). */
  amount: string;
  /** Approx USD for portfolio tiles only — not for debit checks. */
  usd: number;
  price: number;
  change24h: number;
  /** Shown in asset lists when the user has presale access (even at 0). */
  visible: boolean;
}

export const INCPT_NETWORK = 'TRC-20';

export function useIncptAsset(): IncptAsset {
  const { visible: accessVisible, round, balance } = usePresale();
  const amount = typeof balance === 'string' ? balance : String(balance ?? '0');
  const tokensApprox = decimalToApproxNumber(amount);
  return {
    symbol: round.symbol,
    network: INCPT_NETWORK,
    amount,
    usd: accessVisible && Number.isFinite(tokensApprox) ? tokensApprox * round.marketPrice : 0,
    price: round.marketPrice,
    change24h: round.marketChange24h,
    /** Shown whenever the user may see the presale (even at 0 holdings). */
    visible: accessVisible,
  };
}
